import OrderRecommendRequest from '@/http/OrderRecommendRequest'
import ErrorResponseHandler from '@/utility/ErrorResponseHandler'

const orderRecommend = {
  namespaced: true,
  state: {
    orderRecommends: [],
  },
  getters: {
    getOrderRecommends: (state) => {
      return state.orderRecommends
    },
    getOrderRecommendById: (state) => (id) =>
      state.orderRecommends.find(
        (orderRecommend) => orderRecommend.orderRecommendId === Number(id)
      ),
  },
  actions: {
    getOrderRecommends: ({ commit }) => {
      const request = new OrderRecommendRequest()
      request
        .getList()
        .then(({ data }) => {
          commit('setOrderRecommends', data.list)
        })
        .catch((err) => {
          ErrorResponseHandler.redirectErrorPage(err.response)
        })
    },
  },
  mutations: {
    setOrderRecommends(state, orderRecommends) {
      state.orderRecommends = orderRecommends
    },
  },
}

export default orderRecommend
